import React, { useState, useEffect, useCallback } from 'react';
import { StyledHeading } from '../../components/Dashboard/styles.js';
import { Table } from 'antd';
import { getFailedComplexEmails } from '../../utils/services/complexEmailAPI.js'
import { withTranslation } from 'react-i18next';
import { FAILED_TEMPLATES_TABLE } from './TranslationValues.js';
const NAMESPACES = 'FAILED_TEMPLATES_TABLE';

const ComplexEmailFailedTransactions = ({
  title,
  columns,
  date,
  activeTab,
  selectedTeam,
  setChartSectionLoader,
  viewType,
  templatesView,
  t,
}) => {
  const [failureDocumentData, setFailureDocumentData] = useState({});
  
  useEffect(() => {
    if(templatesView && viewType === 0)
    handleChange(1, {}, {});
  }, [viewType, date, activeTab, selectedTeam]);

  const tableLocale = {
    filterConfirm: t(FAILED_TEMPLATES_TABLE.DROPDOWN_CONFIRM_BUTTON.key, FAILED_TEMPLATES_TABLE.DROPDOWN_CONFIRM_BUTTON.value),
    filterReset: t(FAILED_TEMPLATES_TABLE.DROPDOWN_RESET_BUTTON.key, FAILED_TEMPLATES_TABLE.DROPDOWN_RESET_BUTTON.value),
    emptyText: t(FAILED_TEMPLATES_TABLE.NO_DATA_TEXT.key, FAILED_TEMPLATES_TABLE.NO_DATA_TEXT.value),
  };


  const handleChange = async (pagination, filters, sorter) => {
    const payload = {
      startDate: date.startDate,
      endDate: date.endDate,
      page: 1,
      limit: 7,
    };
    if(pagination.current) {
      payload.page = pagination.current;
    }
    if (sorter.hasOwnProperty('order')) {
      payload.isAscending = sorter.order === 'ascend';
    }
    if (filters.hasOwnProperty('failureReason') && filters.failureReason.length !== 0) {
      payload.failureReason = filters.failureReason[0];
    }
    if(selectedTeam) {
      payload.teamId = selectedTeam;
    }
    Object.keys(filters).forEach((filterKey) => {
      if (filters[filterKey][0] !== undefined) {
        payload[filterKey] = filters[filterKey][0];
      }
    });
    try {
      setChartSectionLoader(true);
      const res = await getFailedComplexEmails({ env: activeTab, payload: payload });
      setFailureDocumentData(res);
      setChartSectionLoader(false);
    } catch (e) {
      setChartSectionLoader(false);
    }
  };

  const getPaginationStatus = useCallback(() => {
    if (
      failureDocumentData?.data?.hasOwnProperty('emailFailureList') &&
      failureDocumentData.data.emailFailureList.length > 0
    ) {
      return {
        total: failureDocumentData.dataCount,
        size: 'small',
        pageSize: 7,
      };
    }
    return false;
  }, [failureDocumentData]);

  return (
    <>
      <StyledHeading>
        <h2>{title}</h2>
      </StyledHeading>
        <Table
          className="failed-templates-table"
          dataSource={
            failureDocumentData?.data?.hasOwnProperty('emailFailureList')
              ? 
              failureDocumentData.data.emailFailureList
              : []
          }
          rowKey={record => record.transactionId}
          columns={columns}
          pagination={getPaginationStatus()}
          onChange={handleChange}
          locale={tableLocale}
        />
    </>
  );
};

export default withTranslation(NAMESPACES)(ComplexEmailFailedTransactions);
